/* eslint-disable react/button-has-type */
import React from 'react';
import {
  Footer as UpgradeFooter,
  FooterLinksItem,
  FooterBankNotice as UpgradeFooterBankNotice,
  Logo as UpgradeLogo
} from '@upgrade/react-components';
import { ALL_PRODUCTS } from '@upgrade/react-components/FooterBankNotice/types';
import env from '@upgrade/ui-utils/env';
import { joinPaths } from '@upgrade/ui-utils/utils/url';
import { useTheme } from 'styled-components';

import { Link } from 'gatsby';
import { Text } from './common/TypographyPublicSite';

import { toHtmlSanitize } from '../utils/remark-html';
import { FooterContainer } from './styles';
import {
  AB_PATH,
  ACCESSIBILITY_PATH,
  AR_PATH,
  CAREERS_PATH,
  CH_PATH,
  CREDIT_HEALTH_INSIGHTS_PATH,
  PCL_ONE_CARD_PATH,
  PL_PATH,
  PREMIER_SAVINGS_PATH,
  PR_PATH,
  REVIEWS_PATH,
  REWARDS_CHECKING_PLUS_PATH,
  SECURITY_PATH,
  UPGRADE_CARD_PATH,
  HOME_IMPROVEMENT_PATH,
  AUTO_FINANCE_DEALER_PATH,
  AUTO_FINANCE_CUSTOMER_PATH,
  FLEX_PAY,
  FLEX_PAY_FIND_PARTNERS,
  FLEX_PAY_PARTNERS
} from '../constants/path-constants';

const onClick = url =>
  window.open(url, '', 'width=820,height=630,resizable=no,scrollbars=yes,status=no,toolbar=no,menubar=no,location=no');

const isFlexPayPagesEnabled =
  env.GATSBY_FLEX_PAY_PAGES_ENABLED === 'true' || process.env.GATSBY_FLEX_PAY_PAGES_ENABLED === 'true';

const links = [
  <li key="products-li">
    <Text bold className="footer-menu__category">
      Products
    </Text>
    <ul className="list--unstyled">
      <FooterLinksItem {...{ Link, linkProps: { to: PL_PATH } }}>Personal Loans</FooterLinksItem>
      <FooterLinksItem {...{ Link, linkProps: { to: UPGRADE_CARD_PATH } }}>Upgrade Cards</FooterLinksItem>
      <FooterLinksItem {...{ Link, linkProps: { to: PCL_ONE_CARD_PATH } }}>Upgrade OneCard</FooterLinksItem>
      <FooterLinksItem {...{ Link, linkProps: { to: PREMIER_SAVINGS_PATH } }}>Premier Savings</FooterLinksItem>
      <FooterLinksItem {...{ Link, linkProps: { to: REWARDS_CHECKING_PLUS_PATH } }}>
        Rewards Checking Plus
      </FooterLinksItem>
      <FooterLinksItem {...{ Link, linkProps: { to: AR_PATH } }}>Auto Refinance</FooterLinksItem>
      <FooterLinksItem {...{ Link, linkProps: { to: AUTO_FINANCE_CUSTOMER_PATH } }}>
        Auto Finance: Customers
      </FooterLinksItem>
      <FooterLinksItem {...{ Link, linkProps: { to: AUTO_FINANCE_DEALER_PATH } }}>
        Auto Finance: Dealers
      </FooterLinksItem>
      {isFlexPayPagesEnabled ? (
        <>
          <FooterLinksItem {...{ Link, linkProps: { to: FLEX_PAY } }}>Flex Pay: How It Works</FooterLinksItem>
          <FooterLinksItem {...{ Link, linkProps: { to: FLEX_PAY_FIND_PARTNERS } }}>
            Flex Pay: Travel and Retail Partners
          </FooterLinksItem>
          <FooterLinksItem {...{ Link, linkProps: { to: FLEX_PAY_PARTNERS } }}>
            Flex Pay: Become a Partner
          </FooterLinksItem>
        </>
      ) : null}
      <FooterLinksItem {...{ Link, linkProps: { to: HOME_IMPROVEMENT_PATH } }}>
        Home Improvement: Contractors
      </FooterLinksItem>
      <FooterLinksItem {...{ Link, linkProps: { to: CH_PATH } }}>Credit Health</FooterLinksItem>
    </ul>
  </li>,
  <li key="company-li">
    <Text bold className="footer-menu__category">
      Company
    </Text>
    <ul className="list--unstyled">
      <FooterLinksItem {...{ Link, linkProps: { to: AB_PATH } }}>About Us</FooterLinksItem>
      <FooterLinksItem {...{ Link, linkProps: { to: CAREERS_PATH } }}>Careers</FooterLinksItem>
      <FooterLinksItem {...{ Link, linkProps: { to: joinPaths(PR_PATH, '/memos') } }}>Press Room</FooterLinksItem>
      <FooterLinksItem {...{ Link, linkProps: { to: REVIEWS_PATH } }}>Reviews</FooterLinksItem>
    </ul>
  </li>,
  <li key="res-li">
    <Text bold className="footer-menu__category">
      Resources
    </Text>
    <ul className="list--unstyled">
      <FooterLinksItem {...{ Link, linkProps: { to: CREDIT_HEALTH_INSIGHTS_PATH } }}>
        Credit Health Insights
      </FooterLinksItem>
      <FooterLinksItem target="_blank" href="https://upgrade.zendesk.com/hc/en-us" linkProps={{ rel: 'noopener' }}>
        Help Center
      </FooterLinksItem>
      <FooterLinksItem {...{ Link, linkProps: { to: SECURITY_PATH } }}>Security</FooterLinksItem>
      <FooterLinksItem {...{ Link, linkProps: { to: ACCESSIBILITY_PATH } }}>Accessibility</FooterLinksItem>
    </ul>
  </li>,
  <li key="legal-li">
    <Text bold className="footer-menu__category">
      Legal
    </Text>
    <ul className="list--unstyled">
      <FooterLinksItem onClick={() => onClick('/funnel/borrower-documents?id=1')}>Terms of Use</FooterLinksItem>
      <FooterLinksItem href="/funnel/borrower-documents/PRIVACY_POLICY?productType=PERSONAL_LOAN">
        Privacy
      </FooterLinksItem>
      <FooterLinksItem linkProps={{ id: 'ot-sdk-bt', className: 'ot-sdk-show-settings' }}>
        Do Not Sell or Share
        <br />
        Personal Information
      </FooterLinksItem>
      <FooterLinksItem
        linkProps={{ rel: 'noopener' }}
        target="_blank"
        href="https://upgrade-requests.my.onetrust.com/webform/dbeb549a-dd3b-40da-a19c-bf5dd64371a1/948265a9-0a0d-4e95-95f9-954a02b41094"
      >
        Limit the Use of My
        <br />
        Sensitive Personal
        <br />
        Information
      </FooterLinksItem>
    </ul>
  </li>
];

const contact = () => {
  const handleCopy = (e, email) => {
    e.preventDefault();
    e.clipboardData.setData('text/plain', email);
  };

  return (
    <Text as="p" size="xs" weight={300}>
      For inquiries, contact us at
      <br />
      <Text className="footer-contact" onCopy={e => handleCopy(e, 'contact@upgrade.com')}>
        moc.edargpu<Text className="hidden">null</Text>@tcatnoc<Text className="hidden">null</Text>
      </Text>
    </Text>
  );
};

const Footer = ({
  margin = true,
  legal: legalMarkdown,
  notice: noticeType,
  withNydigNotice,
  whiteFooter,
  customLegal
}) => {
  const theme = useTheme();

  const legal = legalMarkdown && (
    // eslint-disable-next-line react/no-danger
    <div dangerouslySetInnerHTML={{ __html: toHtmlSanitize(legalMarkdown, { removeWrappingPTag: false }) }} />
  );

  const logo = (
    <Link>
      <UpgradeLogo direction="vertical" color={theme.palette.actionablePrimary} className="footer__logouu" />
    </Link>
  );

  const notice = (
    <UpgradeFooterBankNotice
      type={noticeType || ALL_PRODUCTS}
      withNydigNotice={withNydigNotice}
      withDeposit
      showLendingPartners
      withAutoRefinance
      publicSiteUrl=""
      version="v2"
    />
  );

  const footer = (
    <UpgradeFooter
      {...{
        links,
        contact: contact(),
        legal: customLegal || legal,
        notice,
        ...(whiteFooter ? { logo } : {})
      }}
    />
  );

  return margin ? footer : <FooterContainer {...{ whiteFooter }}>{footer}</FooterContainer>;
};

export default Footer;
